<template>
  <div>
    <div class="geo-news-title d-flex align-items-end justify-content-center container-fluid" style="padding-left:0">
      <div>
        <h2 class="featured-news">Featured News</h2>
      </div>
      <div class="ml-auto" style="margin-bottom: 22px;">
        <a :href="activeCountrySection.geoPath" class="all-geo-news">All {{activeCountrySection.name}} News</a>
      </div>
    </div>
    <div class="automation-news-articles section-articles news-list" role="" data-country="">
      <article-featured :article="featuredArticle"></article-featured>
      <div class="grid-col-3  feature-list" >
        <article-item v-for="(article) in activeCountrySection.articles.slice(1, 4)" v-bind:key="article.id" :article="article" :country="activeCountrySection.name"></article-item>
      </div>

      <div v-for="(countrySection) in countrySections">
        <div class="geo-news-title d-flex align-items-center justify-content-center container" style="padding-left: 0">
          <div>
            <h4>{{countrySection.name}}</h4>
          </div>

          <div class="ml-auto">
            <a :href="countrySection.geoPath" class="all-geo-news">All {{countrySection.name}} News</a>
          </div>
        </div>

        <div class="grid-col-3  feature-list">
          <div v-for="(article) in countrySection.articles.slice(0, 3)">
            <article-item :article="article" :country="countrySection.name"></article-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'articles-global',
  props: {
    articles: {
      required: true,
    },
  },
  computed: {
    activeRegionCode: function(){
      const element = document.querySelector('html').getAttribute('data-ipcountry');
      let code = !element ? 'gb' : (element === 'en-GB' ? 'gb' : element.toLowerCase());

      const validCode = this.data.find(item => item.code === code);
      if (!validCode) {
        code = 'gb';
      }
      return code;
    },
    data: function(){
      return Object.keys(this.articles).map(key => {
        return this.articles[key];
      });
    },
    countrySections: function(){
      return this.data.filter(item => item.code !== this.activeRegionCode).sort((a, b) => a.name.localeCompare(b.name));
    },
    activeCountrySection: function() {
      return this.data.find(item => item.code === this.activeRegionCode);
    },
    featuredArticle: function() {
      return this.activeCountrySection.articles[0];
    },
  },
};
</script>
